import Card from 'components/atoms/Card'
import DisplayCard from 'components/DisplayCard'
import React from 'react'
import {useTranslation} from 'react-i18next'

function DescHeartPage() {
  const {t} = useTranslation()
  const contents = [
    {title: t('IProductName'), content: 'iSyncHeart'},
    {title: t('IItemName'), content: t('ISyncHeartName')},
    {title: t('IModelName'), content: 'ISH-C-001'},
    {title: t('IManuFacturer'), content: t('IMedisyncInc')},
    {title: t('IAddress'), content: t('IAppCompanyAddress')},
    {title: t('ILicenseNumber'), content: t('ILicenseCodeNumber')},
    {title: t('ICertificationNumber'), content: t('ICertificationHeart')},
    {title: t('ISerialNumber'), content: t('ISerialVersion')},
    {title: t('IYearOfManufacture'), content: t('IJuneSix')},
    {title: t('IPackagingUnit'), content: t('INotApplicable')},
    {title: t('IPurposeOfUse'), content: t('ISyncHeartPurpose')},
    {title: t('UDI'), content: '(01)08800108500332'},
  ]
  return (
    <Card>
      <DisplayCard contents={contents} />
    </Card>
  )
}

export default DescHeartPage
